export enum AddonTabEnum {
  DEPARTURE = "departure",
  RETURN = "return",
}

export enum TabType {
  MULTIPLE = "multiple",
  SIMPLE = "simple",
}
export enum PassengerTypeEnum {
  ADULT = "adult",
  CHILD = "child",
  INFANT = "infant",
}
